import { IRootState } from "../../store";

export const selectCatalog = (state: IRootState) => state.catalog.catalog;

export const selectCatalogHistory = (state: IRootState) =>
  state.catalog.catalogHistory;
